import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Fab, Hidden, InputAdornment, InputBase, TextField, Tooltip, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class ElectricalSystems extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
            tableInputsArray: ["6"],
            defaultNumber: 6,
            inputsCount: 5,
            inputsArray: [1,2,3,4,5]
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    appendInput_director() {
        var newInput = `${this.state.tableInputsArray.length + this.state.inputsArray.length + 1}`;
        this.setState(prevState => ({
            tableInputsArray: prevState.tableInputsArray.concat([newInput])
        }));
    }

    setInputFields = () => {
        const { values } = this.props;
        let countArray = [];
        let i = 1;
        if (values.is_correction) {
            Object.keys(values).forEach(key => {
                if (key.includes('target_designation_')) {
                    countArray.push(i)
                    i++
                }
            });

            if (countArray.length > 5) {
                this.setState({inputsArray: countArray})
            }
        }
    }

    componentDidMount() {
        this.setInputFields()
    }

    render() {
        const {
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
            classes
        } = this.props;

        values.start_date = values.start_date ? values.start_date.split(' ')[0] : '';
        values.end_date = values.end_date ? values.end_date.split(' ')[0] : '';
        values.next_examination_date = values.next_examination_date ? values.next_examination_date.split(' ')[0] : '';
        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2

        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item xl={9} xs={12}>
                    <Table border={1}>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    Beginn der Prüfung:
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="start_date"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.start_date}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    Ende der Prüfung:
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="end_date"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.end_date}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Beauftragter des Auftraggebers:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="agent_of_client"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.agent_of_client}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Auftrag Nr:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="order_number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.order_number}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Kunden-Nr:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="customer_number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.customer_number}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Erproben Funktionsprüfung der Anlage:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="testing_the_functional_test"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.testing_the_functional_test}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    FI-Schutzschalter (RCD):
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="cable_lines_power_supply"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.cable_lines_power_supply}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Funktion der Schutz-, Sicherheits:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="function_of_protection_security"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.function_of_protection_security}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Prüfer:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="tester"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.tester}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Gebäudesystemtechnik Kabel, Leitungen, Stromsch.:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="building_system_technology"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.building_system_technology}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Schutz- und Überwachungseinr.
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="protection_against_direct_contact"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.protection_against_direct_contact}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Dokumentation siehe Ergänzungsblätter:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="documentation_supplementary_sheets"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.documentation_supplementary_sheets}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Funktion der Schutz-, Sicherheitsund Überwachungseinrichtungen Drehrichtung der Motore
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="direction_rotation_motors"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.direction_rotation_motors}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Rechtsdrehfeld der Drehstromsteckdose Gebäudesystemtechnik
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="clockwise_rotating_field"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.clockwise_rotating_field}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell width="33%">
                                    Stromkreisverteiler Nr.:
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="circuit_distributor_number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.circuit_distributor_number}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>

                <div>
                    {this.state.inputsArray.map( input => { return (
                            <Grid item xs={12}>
                                <Grid container spacing={16} alignItems={"center"}>
                                    <Grid item xs={1}>
                                        <Typography>{input}</Typography>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Grid container spacing={16} alignItems={"center"}>

                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"target_designation_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Ziel."
                                                    value={values[`target_designation_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"type_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Typ"
                                                    value={values[`type_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"ladder_count_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Anz. Leiter."
                                                    value={values[`ladder_count_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"ladder_cross_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Quers."
                                                    value={values[`ladder_cross_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"char_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Charakteristik"
                                                    value={values[`char_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"in_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="In"
                                                    value={values[`in_${input}`]}

                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"zs_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Zs"
                                                    value={values[`zs_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"riso_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Riso"
                                                    value={values[`riso_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"in_art_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="In/Art"
                                                    value={values[`in_art_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"i_delta_n_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="IΔn"
                                                    value={values[`i_delta_n_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"imess_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Imess."
                                                    value={values[`imess_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"readout_time_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Ausl.-Zeit"
                                                    value={values[`readout_time_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"umess_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Umess"
                                                    value={values[`umess_${input}`]}
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"error_code_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Fehlercode"
                                                    value={values[`error_code_${input}`]}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            <br />

                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>

                            </Grid>

                    )})}
                </div>

                <div>
                    {this.state.tableInputsArray.map( (input, index) => { return (
                            <Grid item xs={12}>
                                <Grid container spacing={16} alignItems={"center"}>
                                    <Grid item xs={1}>
                                        <TextField
                                            value={index + this.state.inputsArray.length + 1}
                                            InputProps={{
                                                endAdornment: index + 1 === this.state.tableInputsArray.length && (
                                                    <InputAdornment position="flex-start">
                                                        <Tooltip title="Add raw">
                                                            <Fab
                                                                color="primary"
                                                                size="small"
                                                                onClick={() => this.appendInput_director()}
                                                            >
                                                                <Icon>
                                                                    add
                                                                </Icon>
                                                            </Fab>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                ),
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Grid container spacing={16} alignItems={"center"}>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"target_designation_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Ziel."
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"type_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Typ"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"ladder_count_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Anz. Leiter."
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"ladder_cross_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Quers."
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"char_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Charakteristik"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"in_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="In"

                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"zs_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Zs"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"riso_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Riso"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"in_art_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="In/Art"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"i_delta_n_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="IΔn"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"imess_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Imess."
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"readout_time_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Ausl.-Zeit"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"umess_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Umess"
                                                />
                                            </Grid>
                                            <Grid xs={3} item>
                                                <TextField
                                                    type="text"
                                                    name={"error_code_" + input}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Fehlercode"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            <br />

                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>

                            </Grid>

                    )})}
                </div>

                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <FormLabel>Prüfergebnis:</FormLabel>
                </Grid>
                <Grid item md={3} xs={4}>
                    <FormRadio
                        name="defect"
                        options={[
                            {
                                value : 'no',
                                label : 'keine Mängel festgestellt'
                            },
                            {
                                value : 'yes',
                                label : 'Mängel festgestellt'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_7_content_2 || ''}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <FormLabel>
                        Prüfplakette angebracht:
                    </FormLabel>
                </Grid>
                <Grid item md={3} xs={4}>
                    <FormRadio
                        name="inspection"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            },
                        ]}
                        onChange={handleChange}
                        className={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.check_7_content_2 || ''}
                    />
                </Grid>


                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    tableFixed:{
        width: "2200px",
        tableLayout: "fixed",
    },
    tableWrapper: {
        overflowX: 'auto'
    },
});

export default withStyles(styles)(ElectricalSystems);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/ElectricalSystems.js